<template>
    <div>
        <app-bar @save="formHandler" :backBtn="{ visible: backBtn }" :navTab="navTab" :isLoading="isLoading">
            <template #title>
                <template v-if="action === 'edit'">Edit {{ merchantClassification == 'BRANCH' ? 'Branch' : 'Merchant' }}</template>
                <template v-if="action === 'add'">Add Merchant</template>
            </template>
            <template v-if="primaryMerchant" #subtitle>
                <span class="text-caption">
                    Primary Merchant: <b> {{ primaryMerchant }}</b>
                </span>
            </template>
        </app-bar>
        <v-form v-model="validateStatus" ref="formData">
            <Form :action="action" :classification="classification" @assignOldClassification="merchantClassification = $event" />
        </v-form>
    </div>
</template>

<script>
import AppBar from '@/components/Core/AppBar.vue';
import Form from '@/components/Core/Form.vue';

export default {
    name: 'EditForm',
    components: {
        AppBar,
        Form
    },
    data() {
        return {
            merchantClassification: '',
            isLoading: false,
            newMerchantDetails: {},
            validateStatus: false
        };
    },
    computed: {
        action() {
            return this.$route.params.action;
        },
        // If merchant login, Show My-QR page (w/o back button)
        backBtn() {
            if (this.userInfo.role.id === 'MERCHANT' && this.action != 'edit') {
                return false;
            }

            return true;
        },
        classification() {
            if (this.$route.params.action == 'add') {
                return 'PRIMARY';
            } else if (this.userInfo.role.id === 'MERCHANT') {
                return this.userInfo.merchant.classification;
            } else if (this.merchantClassification == 'PRIMARY') {
                return 'PRIMARY';
            }
            // else if (this.formDetails.classification == 'PRIMARY') {
            //     return 'PRIMARY';
            // }

            return '';
        },
        formDetails() {
            return this.$store.getters['merchants/getNewMerchantDetails'];
        },
        merchantDetails() {
            return this.$store.getters['merchants/getNewMerchantDetails'];
        },
        navTab() {
            if (this.action == 'edit') {
                return false;
            }

            return true;
        },
        primaryMerchant() {
            if (this.formDetails.classification == 'BRANCH') {
                // (Action: Edit) If selected is branch, set default  merchant name by its merchant
                if (this.formDetails.primary_merchant && this.formDetails.primary_merchant.name) {
                    return this.formDetails.primary_merchant.name;
                }
                // (Action: Add)If selected is branch, set default merchant name by its logged in merchant
                else if (this.userInfo.role.id == 'MERCHANT' && this.userInfo.merchant && this.userInfo.merchant.name) {
                    return this.userInfo.merchant.name;
                }
                // (Action: Add) For add branch, set default by previous merchant
                else if (this.merchantDetails && this.merchantDetails.name) {
                    return this.merchantDetails.name;
                }
            }

            return '';
        }
    },
    watch: {
        formDetails(value) {
            this.newMerchantDetails = value;
            // if (value.primary_merchant && value.primary_merchant.name) {
            //     this.primaryMerchant = value.primary_merchant.name;
            // }
        },
        merchantClassification(value) {
            this.merchantClassification = value;
        }
    },
    methods: {
        formHandler() {
            const handler = {
                add: this.saveMerchant,
                edit: this.editMerchant
            };

            handler[this.action]();
        },
        saveMerchant() {
            let merchantDetails = {};
            for (const [key, value] of Object.entries(this.newMerchantDetails)) {
                if (value != '') {
                    merchantDetails[key] = value;
                }
            }

            if (merchantDetails.activate_setting === 'scheduled' && !merchantDetails.activate_at) {
                this.$refs.formData.validate();
            } else {
                this.isLoading = true;
                let merchantDetails = {};
                for (const [key, value] of Object.entries(this.newMerchantDetails)) {
                    if (value != '') {
                        merchantDetails[key] = value;
                    }
                }

                this.$store
                    .dispatch('merchants/addMerchant', {
                        data: merchantDetails
                    })
                    .then((response) => {
                        this.notification({ type: 'success', message: response.message });
                        this.isLoading = false;
                        if (response.data.uuid) {
                            this.$router.push(this.navigation('to', ['view', response.data.uuid]));
                        } else {
                            this.$router.push(this.navigation('cancel'));
                        }
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            }
        },
        editMerchant() {
            this.isLoading = true;
            let removeFields = [
                'created_by',
                'created_at',
                'id',
                'qr_data',
                'status',
                'updated_at',
                'schedule',
                'batch_number',
                'activate_setting',
                'activate_at',
                'deactivate_at',
                'deactivate_duration',
                'deactivate_duration_unit',
                'deactivate_setting'
            ];

            let merchantDetails = {};
            for (const [key, value] of Object.entries(this.newMerchantDetails)) {
                if (removeFields.indexOf(key) === -1) {
                    merchantDetails[key] = value;
                }
            }

            this.$store
                .dispatch('merchants/setMerchant', {
                    id: this.$route.params.id,
                    data: merchantDetails
                })
                .then((response) => {
                    this.notification({ type: 'success', message: response.message });
                    this.isLoading = false;
                    this.$router.push(this.navigation('cancel'));
                })
                .catch(() => {
                    this.isLoading = false;
                });
        }
    }
};
</script>
